<script>
  import Text from '@components/Text.svelte';
  import { goto } from '$app/navigation';

  export let recRequest;
  export let mobile;
  export let style = '';

  export let tileClicked = function (recRequest) {
    goto(recRequest.token_url);
  };
</script>

<style style="text/scss" lang="scss">
  .rec-request-done {
    background: #2caf87 !important;

    .name-bar {
      color: white !important;
    }
  }

  .rec-object-box {
    color: black;
    background: #ffffff;
    box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.0938593);
    border-radius: 15px;
    width: 100%;
    height: 100%;
    padding: 25px;
    display: flex;
    flex-direction: column;

    &:active,
    &:focus,
    &:hover {
      box-shadow: 0 1.375rem 6.25rem rgba(0, 0, 0, 0.18);
    }

    .top-bar {
      flex-shrink: 0;
      height: 40px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      svg {
        margin-bottom: -3px;
      }
    }

    .name-bar {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      line-height: 24px;
      font-weight: 500;
      font-size: 15px;
    }

    .new-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #2caf87;
      border-radius: 6px;
      width: 48px;
      height: 24px;
      color: white;
      font-size: 12px;
      line-height: 14px;
    }

    .draft-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #999;
      border-radius: 6px;
      width: 48px;
      height: 24px;
      color: white;
      font-size: 12px;
      line-height: 14px;
    }
  }

  .mobile {
    .rec-object-box {
      padding: 20px !important;
    }
  }
</style>

<a
  href={recRequest.token_url}
  on:click|preventDefault|stopPropagation={() => {
    tileClicked(recRequest);
  }}
  class:mobile={mobile}>
  <div class="rec-object-box" style={style} class:rec-request-done={recRequest.completed}>
    <div class="top-bar">
      <div style="flex: 1; flex-shrink: 0; display: flex; align-items: center;">
        {#if recRequest.completed}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16
              3.6 12.4 0 8 0Z"
              fill="#097A57" />
            <path d="M5 7.86997L7.08485 10L11 6" stroke="white" stroke-width="1.5" />
          </svg>
          <span
            style="opacity: 0.65; margin-left: 10px; color: white; line-height:
            18px;">
            Done
          </span>
        {:else}
          <div style="flex: 1">
            {#if recRequest.duration}
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16
                  8C16 3.6 12.4 0 8 0ZM12 9H7V4H9V7H12V9Z"
                  fill="#D5CFEA" />
              </svg>
              <span style="opacity: 0.5; margin-left: 7px;">
                {recRequest.duration} min
              </span>
            {/if}
          </div>

          {#if !mobile}
            <div style="flex-shrink: 0">
              {#if recRequest.aasm_state == 'created'}
                <div class="draft-btn">Draft</div>
              {:else if recRequest.is_new}
                <div class="new-btn">New</div>
              {/if}
            </div>
          {/if}
        {/if}
      </div>
    </div>
    <div class="name-bar">
      <Text
        style="font-weight: 500; font-size: 15px;
        line-height: 24px; display: flex; align-items: flex-end;"
        lines={2}
        text={recRequest.title} />
    </div>
  </div>
</a>
